export const GET_INSTANCE_PERMISSIONS = "GET_INSTANCE_PERMISSIONS";
export const SET_CURRENT_INSTANCE= "SET_CURRENT_INSTANCE";